"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[8403,5814],{

/***/ 12769:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ HeaderBannerContainer_HeaderBannerContainer)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./src/components/inputs/ButtonBase/ButtonBase.tsx
var ButtonBase = __webpack_require__(97127);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
;// CONCATENATED MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const HeaderBannerContainer_module = ({"root":"DB633S"});
;// CONCATENATED MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.tsx







const heightClassMap = {
    48: "h-48",
    56: "h-56",
    64: "h-64"
};
const HeaderBannerContainer = (props)=>{
    const { children, className, to, height, loading, trackParams, onClick, "data-testid": dataTestId } = props;
    const rootClassName = (0,clsx/* default */.Z)(className, HeaderBannerContainer_module.root, "flex items-center justify-center text-white", heightClassMap[height]);
    const content = loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
        name: "32/loader"
    }) : children;
    if (to || onClick) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
            className: (0,clsx/* default */.Z)(rootClassName, "w-full"),
            to: to,
            role: "complementary",
            loading: loading,
            onClick: ()=>{
                (0,analytics/* track */.j)("Banner click", trackParams);
                if (typeof onClick === "function") {
                    onClick();
                }
            },
            "data-testid": dataTestId,
            children: content
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        "data-testid": dataTestId,
        role: "complementary",
        children: content
    });
};
/* harmony default export */ const HeaderBannerContainer_HeaderBannerContainer = (HeaderBannerContainer);


/***/ }),

/***/ 97033:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ LandingSubscriptionHeaderBanner_LandingSubscriptionHeaderBanner)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(63687);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./src/modules/subscription/subscribe/index.tsx
var subscribe = __webpack_require__(70104);
// EXTERNAL MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/SubscribeHeaderBannerBase.tsx + 3 modules
var SubscribeHeaderBannerBase = __webpack_require__(60423);
;// CONCATENATED MODULE: ./src/compositions/banners/LandingSubscriptionHeaderBanner/messages.ts
/* harmony default export */ const messages = ({
    discount: {
        en: "Get {discount} off your first month"
    },
    freeProduct: {
        en: "Get your free fragrance"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/LandingSubscriptionHeaderBanner/LandingSubscriptionHeaderBanner.tsx







const textByOffer = {
    freeProduct: {
        cookieName: constants/* default */.Z.cookieNames.freePerfumeCountdown,
        message: messages.freeProduct
    },
    discount: {
        cookieName: constants/* default */.Z.cookieNames.rootCountdown,
        message: messages.discount
    }
};
// this banner is used on landings and register page
// we show countdowns only fo some
const LandingSubscriptionHeaderBanner = (param)=>{
    let { placement = "Header", isStatic } = param;
    const { isFetching, discountText, formattedPrice, formattedExtraShippingPrice, offerType, cookieCouponCode, couponCode, eventDiscountText, handleSubscribeClick } = (0,subscribe/* useSubscribeOffer */.Hu)();
    // ATTN we don't show default coupon if banner is static, because it's not saved
    if (isStatic && !cookieCouponCode) {
        return null;
    }
    // ATTN we show only limited amount of offers here
    if (!textByOffer[offerType]) {
        return null;
    }
    const { cookieName, message } = textByOffer[offerType];
    const title = {
        ...message,
        values: {
            discount: discountText,
            price: formattedPrice,
            extraShippingPrice: formattedExtraShippingPrice
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeHeaderBannerBase/* default */.Z, {
        title: title,
        loading: isFetching,
        isStatic: isStatic,
        trackParams: {
            placement,
            content: "Subscribe",
            action: "link",
            link: links/* default */.ZP.subscribe,
            discount: eventDiscountText,
            coupon: couponCode
        },
        withCountdown: true,
        countdownCookieName: cookieName,
        onClick: handleSubscribeClick
    });
};
/* harmony default export */ const LandingSubscriptionHeaderBanner_LandingSubscriptionHeaderBanner = (LandingSubscriptionHeaderBanner);


/***/ }),

/***/ 60423:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SubscribeHeaderBannerBase_SubscribeHeaderBannerBase)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(927);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
// EXTERNAL MODULE: ./src/compositions/banners/HeaderBannerContainer/HeaderBannerContainer.tsx + 1 modules
var HeaderBannerContainer = __webpack_require__(12769);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useCountdown.ts
var useCountdown = __webpack_require__(17164);
;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/components/Countdown/messages.ts
/* harmony default export */ const messages = ({
    start: {
        en: "Offer ends in"
    },
    time: {
        en: "{time}"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/components/Countdown/Countdown.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Countdown_module = ({"seconds":"Mngfsm","milliseconds":"DIFWZO"});
;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/components/Countdown/Countdown.tsx







const secondsFormat = "mm [min], ss [sec]";
const millisecondsFormat = "mm [min], ss.S [sec]";
const Countdown = (param)=>{
    let { cookieName, withMilliseconds = true } = param;
    const countdownRef = (0,react.useRef)();
    const { countdownMessage, isExpired } = (0,useCountdown/* default */.Z)({
        nodeRef: countdownRef,
        cookieName,
        initialTime: 20 * 60 * 1000,
        format: withMilliseconds ? millisecondsFormat : secondsFormat,
        withMilliseconds,
        message: messages.time
    });
    if (isExpired) {
        return null;
    }
    const timeClassName = (0,clsx/* default */.Z)("inline-block", withMilliseconds ? Countdown_module.milliseconds : Countdown_module.seconds, withMilliseconds ? "text-black" : null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ". ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "inline-block whitespace-nowrap text-left",
                "data-testid": "timer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                        value: messages.start
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        ref: countdownRef,
                        className: timeClassName,
                        children: countdownMessage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const Countdown_Countdown = (Countdown);

;// CONCATENATED MODULE: ./src/compositions/banners/SubscribeHeaderBannerBase/SubscribeHeaderBannerBase.tsx








// base banner without any logic about offer copy and countdown
const SubscribeHeaderBannerBase = (props)=>{
    const { title, to = links/* default */.ZP.subscribe, trackParams, loading, onClick, isStatic, withArrow, withCountdown, withMilliseconds, countdownCookieName } = props;
    const { isMobile } = (0,useDevice/* default */.Z)();
    const bannerProps = {
        className: "bg-gold-50",
        height: isMobile ? 48 : 64,
        "data-testid": "subscribeBanner",
        loading
    };
    if (!isStatic) {
        bannerProps.to = to;
        bannerProps.trackParams = trackParams;
        bannerProps.onClick = onClick;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderBannerContainer/* default */.Z, {
        ...bannerProps,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                style: isMobile ? "sh6" : "sh5",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "whitespace-nowrap",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                            value: title
                        })
                    }),
                    withCountdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Countdown_Countdown, {
                        cookieName: countdownCookieName,
                        withMilliseconds: withMilliseconds
                    })
                ]
            }),
            withArrow && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                className: "ml-12 flex-none",
                name: "other/long-arrow-right"
            })
        ]
    });
};
/* harmony default export */ const SubscribeHeaderBannerBase_SubscribeHeaderBannerBase = (SubscribeHeaderBannerBase);


/***/ }),

/***/ 23091:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(927);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45881);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78565);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90234);






const NavItem = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((props, ref)=>{
    const { className, to, href, toTab, title, label, exclusiveLabel, withArrow, content, style, color, hoverColor, activeColor, labelColor = "gold-50", isActive, onClick, closeNav, "data-testid": dataTestId } = props;
    const isLabelVisible = Boolean(label);
    const isExclusiveLabelVisible = Boolean(exclusiveLabel);
    const handleClick = (event)=>{
        if (typeof closeNav === "function") {
            closeNav();
        }
        if (typeof onClick === "function") {
            onClick(event);
        }
    };
    const itemClassNames = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, {
        [`text-${color}`]: color && !isActive,
        [`hover:text-${hoverColor}`]: hoverColor,
        [`text-${activeColor}`]: activeColor && isActive,
        [`text-${style}`]: style,
        "cursor-pointer": !isActive
    });
    const renderContent = ()=>{
        if (content) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: content
            });
        }
        const formattedTitle = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            value: title,
            html: true
        });
        if (isExclusiveLabelVisible) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "flex items-center",
                children: [
                    formattedTitle,
                    exclusiveLabel
                ]
            });
        }
        if (isLabelVisible) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    formattedTitle,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        className: "ml-4 inline-block w-0",
                        message: label,
                        style: "eye3",
                        color: labelColor,
                        tag: "sup"
                    })
                ]
            });
        }
        if (withArrow) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    formattedTitle,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                        name: "other/long-arrow-right"
                    })
                ]
            });
        }
        return formattedTitle;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        ref: ref,
        className: itemClassNames,
        to: to,
        href: href,
        toTab: toTab,
        "data-testid": dataTestId,
        onClick: handleClick,
        children: renderContent()
    });
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (NavItem);


/***/ }),

/***/ 1867:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    perfumes: {
        en: "Perfumes"
    },
    allPerfumes: {
        en: "All perfumes"
    },
    bestsellers: {
        en: "Best sellers"
    },
    pom: {
        en: "Perfume of the Month"
    },
    com: {
        en: "Cologne of the Month"
    },
    clean: {
        en: "Clean"
    },
    exclusive: {
        en: "Exclusive"
    },
    collections: {
        en: "Collections"
    },
    colognes: {
        en: "Colognes"
    },
    allColognes: {
        en: "All colognes"
    },
    newArrivals: {
        en: "New arrivals"
    },
    referral: {
        en: "Invite your friends and get a free scent"
    },
    newReferral: {
        en: `
      You have
        <span class="{freeFragranceClassName}">
          <span class="rounded-full text-center inline-flex items-center justify-center w-s18 h-s18 text-[11rem]/[18rem] font-bold font-tt-norms-pro {spanClassName}">
            {available}
          </span>
          free {available, plural, one {fragrance} other {fragrances}}
        </span>
      to give away
    `
    },
    track: {
        en: "Track your order"
    },
    queue: {
        en: "Manage your fragrances"
    },
    makeup: {
        en: "Makeup"
    },
    shop: {
        en: "Shop"
    },
    shopAll: {
        en: "Shop all"
    },
    discover: {
        en: "Discover"
    },
    memberPerks: {
        en: "Member perks"
    },
    gifts: {
        en: "Gift Guide"
    },
    holidayGifts: {
        en: "Holiday Gifts"
    },
    holidayGiftsMothersDay: {
        en: "Mother’s Day Gifts"
    },
    holidayGiftsFathersDay: {
        en: "Father’s Day Gifts"
    },
    exclusives: {
        en: "Gift guide exclusives"
    },
    allGifts: {
        en: "All Gifts"
    },
    giftSubscription: {
        en: "Gift Subscription"
    },
    coarPerfumeGiftSets: {
        en: "COAR Perfume Gift Sets"
    },
    coarCologneGiftSets: {
        en: "COAR Cologne Gift Sets"
    },
    coarShopPage: {
        en: "Confessions&nbsp;of&nbsp;a&nbsp;Rebel"
    },
    sbGiftSets: {
        en: "Scentbird gift sets"
    },
    giftSetsPage: {
        en: "Discovery & Gift Sets"
    },
    giftSets: {
        en: "Gift Sets"
    },
    holidayBoxes: {
        en: "Holiday boxes"
    },
    giftCard: {
        en: "Gift Card"
    },
    giftBundles: {
        en: "Gift bundles"
    },
    mySubscription: {
        en: "My subscription"
    },
    manageDeliveries: {
        en: "Manage my deliveries"
    },
    beauty: {
        en: "Beauty"
    },
    scentbird: {
        en: "Scentbird"
    },
    edit: {
        en: "The Edit"
    },
    fullSizeFragrances: {
        en: "Full-size fragrances"
    },
    scentbirdCases: {
        en: "Scentbird cases"
    },
    bathBody: {
        en: "Bath & Body"
    },
    accessories: {
        en: "Accessories"
    },
    samples: {
        en: "1.5 mL samples"
    },
    travelSizeFragrances: {
        en: "Travel-size fragrances"
    },
    candlesHomeScents: {
        en: `Candles&nbsp;&&nbsp;Home&nbsp;scents`
    },
    scentProfile: {
        en: "Scent profile"
    },
    fragranceFamilies: {
        en: "Fragrance family library"
    },
    allBrands: {
        en: "All brands"
    },
    careers: {
        en: "Careers"
    },
    press: {
        en: "For the press"
    },
    lastMinuteAddons: {
        en: "Last minute add-ons"
    },
    caseSubscription: {
        en: "Case subscription"
    },
    candleSubscription: {
        en: "Candle Club"
    },
    drift: {
        en: "Drift"
    },
    driftSubscription: {
        en: "Car Scent Club by Drift"
    },
    buyYourQueue: {
        en: "Buy your queue and save"
    },
    privateSale: {
        en: "Private sale"
    },
    referralProgram: {
        en: 'Give a free scent, <span class="text-gold-30">get a free scent</span>'
    },
    aboutScentbird: {
        en: "About  scentbird"
    },
    support: {
        en: "Help & Support"
    },
    aboutUs: {
        en: "About us"
    },
    featuredBrand: {
        en: "Featured brand"
    },
    fomArchive: {
        en: "Fragrance of the Month archive"
    },
    scentWorldPodcast: {
        en: "Scent World podcast"
    },
    driftEcommercePromo: {
        en: "Car&nbsp;scents&nbsp;by&nbsp;Drift"
    },
    scentBlog: {
        en: "Scent blog"
    },
    membership: {
        en: "Your membership"
    },
    orderHistory: {
        en: "Order tracking & history"
    },
    manageSubscription: {
        en: "Manage subscription"
    },
    upgrade: {
        en: "Upgrade your subscription"
    },
    subscribe: {
        en: "Subscribe to Scentbird"
    },
    account: {
        en: "Your account"
    },
    billingInfo: {
        en: "Billing information"
    },
    shippingInfo: {
        en: "Shipping information"
    },
    personalInfo: {
        en: "Personal details"
    },
    reviews: {
        en: "Ratings & Reviews"
    },
    logoff: {
        en: "Log out"
    },
    aria: {
        profileButton: {
            en: "open profile menu"
        }
    },
    labels: {
        subscribed: {
            en: "You're subscribed!"
        },
        newAtScentbird: {
            en: "New at scentbird"
        },
        new: {
            en: "New!"
        },
        sale: {
            en: "Sale!"
        }
    },
    notesLibrary: {
        en: "Notes library"
    },
    scentbirdSelect: {
        en: "Scentbird Select"
    },
    scentHoroscope: {
        en: "Scent Horoscope"
    },
    upgrade2Scents: {
        en: "2 Scents a&nbsp;Month"
    },
    upgradeGet2Scents: {
        en: "Get 2 Scents a&nbsp;Month"
    },
    scentbirdAcademy: {
        en: "Scentbird Academy with&nbsp;Jo&nbsp;Malone&nbsp;CBE"
    },
    sale50: {
        en: "Sale! Up to 50% off"
    },
    giftsUnder50: {
        en: "Gifts under $50"
    },
    perfumeSubscription: {
        en: "Perfume subscription"
    },
    recommendedForYou: {
        en: "Recommended for You"
    },
    palmRoyaleCollaboration: {
        en: "Apple TV+ Palm Royale"
    }
});


/***/ }),

/***/ 46094:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ LandingLayout_LandingLayout)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(95812);
// EXTERNAL MODULE: ./local_modules/router/shared/hooks.ts
var hooks = __webpack_require__(91746);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(64667);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(63687);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(40038);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(45881);
// EXTERNAL MODULE: ./src/components/dataDisplay/Logo/Logo.tsx
var Logo = __webpack_require__(53409);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(34212);
// EXTERNAL MODULE: ./src/compositions/banners/LandingSubscriptionHeaderBanner/LandingSubscriptionHeaderBanner.tsx + 1 modules
var LandingSubscriptionHeaderBanner = __webpack_require__(97033);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/hooks/useLandingSetup.ts
var useLandingSetup = __webpack_require__(95022);
// EXTERNAL MODULE: ./src/components/dataDisplay/BackgroundImage/BackgroundImage.tsx
var BackgroundImage = __webpack_require__(35838);
;// CONCATENATED MODULE: ./src/compositions/banners/TwelveDaysBanner/messages.ts
/* harmony default export */ const TwelveDaysBanner_messages = ({
    treatYourselfDesktop: {
        en: "Treat yourself this holiday season! Get {discount} off and a free case"
    },
    treatYourselfMobile: {
        en: "Treat yourself this holiday season!"
    }
});

;// CONCATENATED MODULE: ./src/compositions/banners/TwelveDaysBanner/images/mobile-background.svg
const mobile_background_namespaceObject = __webpack_require__.p + "images-svg/mobile-background_e3f70c.svg";
;// CONCATENATED MODULE: ./src/compositions/banners/TwelveDaysBanner/images/desktop-background.svg
const desktop_background_namespaceObject = __webpack_require__.p + "images-svg/desktop-background_1fd7c3.svg";
;// CONCATENATED MODULE: ./src/compositions/banners/TwelveDaysBanner/TwelveDaysBanner.tsx









const TwelveDaysBanner = ()=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    const { country } = (0,user/* useUser */.aF)();
    const { discountAmount, discountPercent } = (0,useLandingSetup/* default */.Z)({
        couponCode: country === "CA" ? "HD60CA" : "HD60",
        country
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* default */.Z, {
        className: (0,clsx/* default */.Z)("text-center", isMobile ? "p-24" : "p-20"),
        src: isMobile ? mobile_background_namespaceObject : desktop_background_namespaceObject,
        sizes: "100vw",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            style: "h8",
            color: "white",
            message: isMobile ? TwelveDaysBanner_messages.treatYourselfMobile : {
                ...TwelveDaysBanner_messages.treatYourselfDesktop,
                values: {
                    discount: discountAmount || discountPercent
                }
            }
        })
    });
};
/* harmony default export */ const TwelveDaysBanner_TwelveDaysBanner = (TwelveDaysBanner);

// EXTERNAL MODULE: ./src/compositions/Header/Header.tsx
var Header = __webpack_require__(64668);
// EXTERNAL MODULE: ./src/compositions/Header/components/MainHeader/MainHeader.tsx + 1 modules
var MainHeader = __webpack_require__(41612);
// EXTERNAL MODULE: ./src/compositions/Footer/Footer.tsx + 6 modules
var Footer = __webpack_require__(20598);
;// CONCATENATED MODULE: ./src/layouts/LandingLayout/LandingLayout.tsx
















const LandingLayout = (param)=>{
    let { children } = param;
    const pathname = (0,hooks/* usePathname */.jD)();
    const { isLoggedIn } = (0,user/* useUser */.aF)();
    const isHomePage = pathname === links/* default */.ZP.home || pathname === links/* default */.ZP.homeMen;
    const isTwelveDaysPages = pathname === links/* default */.ZP.twelveDays;
    const isBlackFridayBannerVisible = (0,useFt/* default */.Z)(constants/* default */.Z.features.blackFridayTopHomePageBanner);
    const isCyberMondayBannerVisible = (0,useFt/* default */.Z)(constants/* default */.Z.features.cyberMondayTopHomePageBanner);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex min-h-full flex-col",
        children: [
            !isHomePage && !isTwelveDaysPages && /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingSubscriptionHeaderBanner/* default */.Z, {}),
            isTwelveDaysPages && /*#__PURE__*/ (0,jsx_runtime.jsx)(TwelveDaysBanner_TwelveDaysBanner, {}),
            isHomePage || isTwelveDaysPages ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                logoLink: null,
                withSubHeader: false,
                withSupNav: false,
                withBanner: isBlackFridayBannerVisible || isCyberMondayBannerVisible
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainHeader/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                        className: "flex-1 text-center",
                        color: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-4 flex-1 text-right",
                        children: !isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Href/* default */.Z, {
                            to: `${links/* default */.ZP.login}?redirect=${encodeURIComponent(links/* default */.ZP.subscribe)}`,
                            onClick: ()=>{
                                (0,analytics/* track */.j)("Login button click");
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                tag: "span",
                                message: messages/* default */.Z.login,
                                style: "t2"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: "main",
                className: "flex-auto",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {})
        ]
    });
};
/* harmony default export */ const LandingLayout_LandingLayout = (LandingLayout);


/***/ }),

/***/ 35000:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    theValentinesEdit: {
        en: `The Valentine's Edit`
    },
    theLuxeEdit: {
        en: "The Luxe Edit"
    }
});


/***/ })

}]);